import React from 'react'
import Header from './Header';
import Home from '../pages/Home';
import FeaturesSection from '../pages/FeaturesSection';
import HowItWorks from '../pages/HowItWorks';
import AboutSection from '../pages/AboutSection';


function Main() {
  return (
    <div>
        <Header />
        <Home />
        <FeaturesSection />
        <HowItWorks />
        <AboutSection />
    </div>
  )
}

export default Main